import { useState, useEffect, useCallback } from "react";
import { ApiResponse } from "apisauce";
import { toast } from "react-toastify";

import { TicketServiceInterface } from "../interface/TicketServiceInterface";
import { history } from "..";

export function useTicketCrud<T>(
  id: string,
  service: TicketServiceInterface<T>
) {
  const [ticket, setTicket] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);

  const loadTicket = useCallback(async () => {
    setLoading(true);
    const response: ApiResponse<any> = await service.getTicket(id);
    if (response.ok && response.data) {
      setTicket(response.data);
    } else {
      toast.error("Failed to load ticket");
    }
    setLoading(false);
  }, [id, service]);

  useEffect(() => {
    loadTicket();
  }, [loadTicket]);

  const onSave = async () => {
    if (!ticket) return;
    const response: ApiResponse<any> = await service.saveTicket(ticket);
    if (response.ok) {
      toast.success("Ticket saved");
      history.goBack();
    } else {
      toast.error("Failed to save ticket");
    }
  };

  const updateField = (field: keyof T, value: any) => {
    if (!ticket) return;
    setTicket({ ...ticket, [field]: value });
  };

  return { ticket, setTicket, loading, loadTicket, onSave, updateField };
}
